import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";

import DeletionRequestsTable from "../../components/DeletionRequests/DeletionRequestsTable";





const DeletionRequestPage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="DeletionRequests" />

       {/* Projects Table */}
        <DeletionRequestsTable />

      </MasterLayout>
    </>
  );
};

export default DeletionRequestPage;
